import angular from 'angular';
import loanAppLendingFee from './loanAppLendingFee';

export default angular
  .module('components.loanAppLendingFee', [])
  .component('loanAppLendingFee', loanAppLendingFee).name;
